import Internacao from '@/views/Internacao'
import { createRouter, createWebHashHistory } from 'vue-router';

const rotas = [
    {
        path: '/:id',
        name: 'Internacao',
        component: Internacao,
        
        // redirect: '/teste :id'

        // alias :`/:id`
        // ${Math.floor(Math.random() * 101)}
    }
];

const roteador = createRouter({
    history: createWebHashHistory(),
    routes: rotas
});

// beforeRouteEnter (to, from, next) {
//     next(vm => {
//        console.log(vm)
//     });
// }

// roteador.beforeRouteEnter((routeTo, routeFrom, next) => {

//       return next({
//         path:'/'
//       });

// })
export default roteador;